import determineUrl from "lib/site/determineUrl";
import { SiteConfig } from "types/site";

const platformUrl = process.env.PLATFORM_URL;

const config: SiteConfig = {
  code: "yec",
  name: "YEC",
  logo: "https://storage.googleapis.com/cco-web-assets/logos/yec-logo.svg",
  favIcon:
    "https://storage.googleapis.com/cco-web-assets/app-icons/yec/icon.png",
  unreadFavIcon:
    "https://storage.googleapis.com/cco-web-assets/app-icons/yec/icon.png",
  platformUrl,
  appStoreUrl: "https://apps.apple.com/us/app/yec/id1476268894",
  playStoreUrl: "https://play.google.com/store/apps/details?id=co.yec.member",
  loginUrl: determineUrl("login", platformUrl),
  graphEndpoint: determineUrl("graphql", platformUrl),
  publicHost: "https://yec.co",
  publishingWebsite: "",
  defaultAdminCommunity: "yec",
  concierge: {
    email: "concierge@yec.co",
    phone: {
      number: "(617) 712-0447",
    },
  },
  zendesk: {
    apiKey: process.env.ZENDESK_API_KEY,
  },
  stream: {
    apiKey: process.env.STREAM_API_KEY,
    appId: process.env.STREAM_APP_ID,
    apiSecret: process.env.STREAM_API_SECRET,
  },
};

export default config;
